module.exports = __webpack_public_path__ + "static/img/16.d3763e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppt/16.jpg
// module id = i0wf
// module chunks = 1